
import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of a value.
 * It updates only after `delay` ms have passed without changes.
 *
 * @param {*} value Any value to debounce (string, number, object, etc.)
 * @param {number} delay Debounce delay in ms (default 250)
 * @returns {*} debounced value
 */
export default function useDebouncedValue(value, delay = 250) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);

    return debounced;
}
